// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>11</span>&nbsp;&nbsp;But the lowly shall possess the land&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and shall delight in abundance of peace.<br> </p> </div></div>";
// Exports
module.exports = code;